import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_page_title, {
          value: _ctx.$t('admin.title')
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, { class: "pt-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "5" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('admin.switchSchool')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  items: _ctx.schools,
                  modelValue: _ctx.selectedNurseryId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedNurseryId) = $event)),
                  "item-title": "nurseryName",
                  "item-value": "nurseryId",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  disabled: _ctx.loading,
                  color: "primary"
                }, null, 8, ["items", "modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _ctx.saveNurseryId,
                  block: "",
                  color: "primary",
                  variant: "flat"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.change')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}